import type { SiteLastDataDto } from '@hotjar/webapp/domains/activation/tracking-code/dto';
import type { Site } from '@hotjar/site';

import { createEventDefinition } from 'ts-bus';

export const EVENT_SITE_CREATED = 'EVENT_SITE_CREATED';

export const EVENT_SITE_LAST_DATA_REFRESHED = 'EVENT_SITE_LAST_DATA_REFRESHED';

export const EVENT_SITE_URL_UPDATED = 'EVENT_SITE_URL_UPDATED';

export const EVENT_CURRENT_SITE_CHANGED = 'EVENT_CURRENT_SITE_CHANGED';

export const EVENT_CURRENT_SITE_SET = 'EVENT_CURRENT_SITE_SET';

export const siteCreatedEvent = createEventDefinition()(EVENT_SITE_CREATED);

export const siteLastDataRefreshed = createEventDefinition<{
  site: Site;
  state: SiteLastDataDto;
}>()(EVENT_SITE_LAST_DATA_REFRESHED);

export const siteUrlUpdated = createEventDefinition()(EVENT_SITE_URL_UPDATED);

export const currentSiteChanged = createEventDefinition()(EVENT_CURRENT_SITE_CHANGED);

export const currentSiteSet = createEventDefinition<{ site: Site }>()(EVENT_CURRENT_SITE_SET);
